module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/seller/seller-header/seller-header.component.scss
// module id = ./src/app/seller/seller-header/seller-header.component.scss
// module chunks = main